import { render } from "./RequestTile.vue?vue&type=template&id=4a872bbe"
import script from "./RequestTile.vue?vue&type=script&lang=js"
export * from "./RequestTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__